import Vue from 'vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 详细文稿： https://github.com/rstacruz/nprogress.git

NProgress.inc(0.2)
NProgress.configure({
  easing: 'ease',
  speed: 500,
  showSpinner: false
})

Vue.prototype.$NProgress = NProgress;